<template>
  <div class="box-wrap active-box-wrap" :style="boxWrapStyleObj">
    <span class="border-left-top"></span>
    <span class="border-left-bottom"></span>
    <span class="border-right-top"></span>
    <span class="border-right-bottom"></span>
    <div class="statis-title bg1" style="display: flex; justify-content: center" :ref="`${activeType}_statisTitle`">
      <span>{{ title }}</span><span class="split-line">|</span>
      <div class="active-statis">
        <Select v-model="timeSolt" ref="timeIntervalSelectRef" placeholder="全部时段" @on-change="changeTimeSolt">
          <!-- <Option value="0">全部时段</Option> -->
          <Option value="1">本学年</Option>
          <Option value="2">本月</Option>
          <Option value="3">本周</Option>
        </Select>
      </div>
    </div>
    <div class="active-static-tab-content" :style="contentStyleObj">
      <active-content :activeType="activeType" ref="activeTypeRef" :rankingList="activeGradeList" :tabCode="tabCode"
        :gradeList="gradeList" @update-selected-data="updateSelectedData"></active-content>
    </div>
  </div>
</template>

<script>
import {
  findGradeList,
  getTeaEvaluateTop,
  findHomeworkActiveGrade,
  findMicroActiveGrade,
  findResourceActiveGrade,
  findLearningActiveGrade,
  findInteractActiveGrade,
  getSchoolGrade,
} from "../../../service/bigDataApi.js";
import { getSchoolYearAPI } from "../../../service/api.js";
import CountUp from "../../../components/countUp.vue";
import activeContent from "./activeContent.vue";
export default {
  name: "teacher-evaluation-board",
  data() {
    return {
      screenWidth: 0, //屏幕宽度
      boxWrapStyleObj: {
        height: "",
      },
      contentStyleObj: {
        height: "",
      },
      styleObj: {
        width: "100%",
        height: "100%",
      },
      countWeight: 400,
      tabList: [
        {
          code: "resTab",
          title: "分享课件数",
        },
        {
          code: "microTab",
          title: "分享微课数",
        },
        {
          code: "hwTab",
          title: "布置作业数",
        },
        {
          code: "studyTab",
          title: "探究学习",
        },
        {
          code: "interTab",
          title: "互动答疑",
        },
      ],
      timeSolt: "1",
      startDate: "",
      endDate: "",
      tabCode: "evaluation",
      activeGradeList: [],
      activeClassList: [],
      activeTeacherList: [],
      curActiveGradeData: {}, //当前年级活跃下的统计数据
      gradeList: [],
      subjectList: [],
      gradeId: "",
      subjectId: "",
      systemCode: '',
      year: '',
      title: "教师评价榜",
      activeType: "evaluation",
      channel: process.env.VUE_APP_CHANNEL,
      schoolYear: '',
    };
  },
  components: {
    CountUp,
    activeContent,
  },
  props: {
    screenHeight: Number,
    titleHeight: Number,
    schoolId: String,
    schoolName: String,
    schoolCode: String,
    phase: { type: String, default: '' },
  },
  watch: {
    screenHeight: "initBoxHeight",
    titleHeight: "initBoxHeight",
    // 父组件学段切换时重新加载数据
    phase() {
      this.getTeaEvaluateTopInfo();
    },
  },
  methods: {
    /**
     * 初始化box高度
     */
    initBoxHeight() {
      let titleRef = this.activeType + "_statisTitle";
      let tabRef = this.activeType + "_staticTabRef";
      let winHeight = window.innerHeight;
      if (winHeight < 900) {
        winHeight = 938;
      }
      let boxWrapHeight = (winHeight - 128 - 10 - 30) / 3;
      let contentHeight =
        boxWrapHeight -
        this.$refs[titleRef].offsetHeight - 20;
      this.boxWrapStyleObj.height = boxWrapHeight + "px";
      this.contentStyleObj.height = contentHeight + "px";
    },
    async getSchoolYear() {
      await getSchoolYearAPI({ schoolid: this.schoolId }).then(data => {
        this.schoolYear = data[0].schoolYear;
      })
    },
    /**
     * 获取年级列表
     */
    async getGradeList() {
      let _this = this;
      let param = {
        schoolId: this.schoolId,
      };
      await getSchoolGrade(param)
        .then(function (data) {
          _this.gradeList = data;
        })
        .catch(function (error) {
          _this.$Message.error(error.message);
        });
    },
    /**
     * 选择时间段
     */
    changeTimeSolt() {
      // let todayStr = this.$utils.getNDayStr(1)
      //   ;
      // this.endDate = todayStr + " 23:59:59";
      // //获取近一周时间
      // if (this.timeSolt === "1") {
      //   this.startDate = this.$utils.getYestodaySevenDayStr(1) + " 00:00:00";
      // } else if (this.timeSolt === "2") {
      //   //获取近一月时间
      //   this.startDate = this.$utils.getPreMonthDay(todayStr, 1) + " 00:00:00";
      // } else if (this.timeSolt === "3") {
      //   //获取本学年时间
      //   this.startDate = this.judgeSchoolYear() + "-08-10 00:00:00";
      //   this.endDate = this.judgeSchoolYear() + 1 + "-08-09 23:59:59";
      // } else {
      //   this.startDate = "";
      //   this.endDate = "";
      // }
      this.getTeaEvaluateTopInfo();
    },
    judgeSchoolYear() {
      let currentDate = new Date().getTime();
      let currentSchoolYear = new Date(
        new Date().getFullYear() + "-08-10 00:00:00"
      ).getTime();
      if (currentDate < currentSchoolYear) {
        return new Date().getFullYear() - 1;
      } else {
        return new Date().getFullYear();
      }
    },
    /**
     * 教师评价数据信息
     */
    async getTeaEvaluateTopInfo() {
      let _this = this;
      let param = {
        schoolId: this.schoolId,
        schoolYear: this.schoolYear,
        classYear: this.year,
        systemCode: this.systemCode,
        dateType: this.timeSolt
      };
      let token;
      if (token) {
        param.token = token;
      } else {
        param.token = '15e80c01423e649eee0b77e5eaac1a4fd64d73b05c00189620303dd713f5f9eae5671d4e7be504d2a0f8076ade17db50ef2029d67234d5f1';
      }
      // if (this.startDate != "" && this.endDate != "") {
      //   param.startTime = this.startDate;
      //   param.endTime = this.endDate;
      // }
      await getTeaEvaluateTop(param)
        .then(function (data) {
          _this.activeGradeList = data
        })
        .catch(function (error) {
          _this.$Message.error(error.message);
        });
    },
    /**
     * 更新当前选中的学科id或年级id
     */
    updateSelectedData(subjectId, gradeId) {
      const obj = this.gradeList.find(item => item.gradeId === gradeId);
      if (obj) {
        this.systemCode = obj.systemCode;
        this.year = obj.year
      } else {
        this.systemCode = ''
        this.year = ''
      }
      this.getTeaEvaluateTopInfo();
    },
  },
  async mounted() {
    await this.getSchoolYear();
    await this.getGradeList();
    await this.getTeaEvaluateTopInfo();
  },
};
</script>

<style lang="scss" scoped>
@import "../../../style/databoard";
@import "../../../style/layout";

.bg1 {
  background-image: url("../../../assets/images/sydataboard/title-bg.png");
}

.active-static-tab-item {
  background-image: url("../../../assets/images/databoard/icon_tab_normal.png");
}

.active-static-tab-item-selected {
  background-image: url("../../../assets/images/databoard/icon_tab_hover.png");
}

.active-box-more-txt i {
  background-image: url(../../../assets/images/databoard/active-icon.png);
  background-position: -299px 90px;
}

.active-static-icon-arrow-down {
  background-image: url(../../../assets/images/databoard/active-icon.png);
  background-position: -224px 90px;
}
</style>

<style lang="scss">
.active-statis {
  .ivu-select-selection {
    box-shadow: transparent !important;
    background-color: transparent !important;
    border: transparent !important;
  }

  .ivu-select-single .ivu-select-selection .ivu-select-placeholder,
  .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
    font-size: 16px !important;
    color: #ffffff !important;
    padding-left: 0 !important;
  }

  .ivu-select-arrow {
    color: #ffffff !important;
  }

  .ivu-select-dropdown {
    max-height: 100px;
    background: rgba(10, 18, 39, 0.97);
    box-shadow: inset 0px 0px 10px 4px rgba(14, 252, 255, 0.15) !important;
    border-radius: 5px;
  }

  .ivu-select-item {
    color: #ffffff !important;
    text-align: center;
  }

  .ivu-select-item:hover {
    background: #ffffff !important;
    color: #0a1227 !important;
  }

  .ivu-select-item-focus {
    background: #ffffff !important;
    color: #0a1227 !important;
  }
}
</style>
